import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SpinnerLoading from '../../components/pageComponents/SpinnerLoading';

const TableWebBodyEvaluaciones = ({
  filas = [],
  onEditEvaluacion,
  onPreviewEvaluacion,
  isLoading = false
}) => {

  const handleEditClick = (event, evaluacion) => {
    event.preventDefault();
    event.stopPropagation();
    if (onEditEvaluacion) {
      onEditEvaluacion(evaluacion);
    }
  };

  const handlePreviewClick = (event, evaluacion) => {
    event.preventDefault();
    event.stopPropagation();
    if (onPreviewEvaluacion) {
      onPreviewEvaluacion(evaluacion);
    }
  };

  if (isLoading) {
    return (
      <tbody>
        <tr>
          <td colSpan="6" className="text-center py-5">
            <div className="spinner-border text-primary" role="status">
              <span className="sr-only">Cargando...</span>
            </div>
            <div className="mt-2">Cargando...</div>
          </td>
        </tr>
      </tbody>
    );
  }

  if (!filas || filas.length === 0) {
    return (
      <tbody>
        <tr>
          <td colSpan="6" className="text-center py-5">
            <div className="text-center">
              <FontAwesomeIcon icon="search" size="3x" className="text-muted mb-3" />
              <h5 className="text-muted">No se encontraron evaluaciones</h5>
              <p className="text-muted">Intenta ajustar los filtros de búsqueda</p>
            </div>
          </td>
        </tr>
      </tbody>
    );
  }

  return (
    <>
      <tbody className="listar-tbody">
        {filas.map((evaluacion, index) => (
          <tr key={`${index}-${evaluacion.IdEvaluacion}`} className="table-row">
            {/* Fecha Creación */}
            <td className="text-center align-middle">
              <span className="font-weight-normal">
                {evaluacion.FechaCreacion}
              </span>
            </td>

            {/* Nombre Evaluación */}
            <td className="align-middle">
              <div className="d-flex flex-column">
                <span className="font-weight-bold text-primary">
                  {evaluacion.NombreEvaluacion}
                </span>
              </div>
            </td>

            {/* Tipo Cargo */}
            <td className="text-center align-middle">
              <span 
                className="badge px-2 py-1"
                style={{
                  backgroundColor: '#28c76f',
                  color: '#ffffff',
                  fontWeight: '500',
                  fontSize: '0.8rem'
                }}
              >
                {evaluacion.TipoCargo}
              </span>
            </td>



            {/* Estado */}
            <td className="text-center align-middle">
              <span className={`badge px-2 py-1 ${
                evaluacion.Estado === 'Activo' ? 'badge-success' : 'badge-secondary'
              }`}>
                {evaluacion.Estado}
              </span>
            </td>

            {/* Acciones */}
            <td className="text-center align-middle">
              <div className="d-flex justify-content-center" style={{gap: "8px"}}>
                <button
                  type="button"
                  className="btn btn-link p-2"
                  onClick={(e) => handleEditClick(e, evaluacion)}
                  title="Editar evaluación"
                  style={{
                    color: "#007bff",
                    fontSize: "16px",
                    border: "none",
                    background: "transparent"
                  }}
                >
                  <FontAwesomeIcon icon="edit" />
                </button>

                <button
                  type="button"
                  className="btn btn-link p-2"
                  onClick={(e) => handlePreviewClick(e, evaluacion)}
                  title="Vista previa"
                  style={{
                    color: "#17a2b8",
                    fontSize: "16px",
                    border: "none",
                    background: "transparent"
                  }}
                >
                  <FontAwesomeIcon icon="eye" />
                </button>
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </>
  );
};

export default TableWebBodyEvaluaciones;